/* global G */
import find from 'lib/sequence/component/children/find'
import { set } from 'lib/sequence/component/state/value'
import { hide } from 'lib/sequence/component/state/hidden'
import { getFirstItem } from 'lib/util'

/**
 * Checks whether `x` has a value, ignoring fallback `-` values.
 *
 * @param {string} x the string to check
 * @returns {boolean}
 * @private
 */
const _hasValue = x => (x
  ? x.replaceAll(' ', '').split('-').join('') !== ''
  : false)

/**
 * Presets the component with a key of `component`, that is optionally wrapped by `parent`,
 * with either a name or email address.
 *
 * Does so by inspecting the values of the `name`, `firstName`, `lastName` and `contactChannels`
 * fields of the current model or submodel in case of `attribute`.
 *
 * Sets the value in the following hierarchy:
 * 1. name
 * 2. `${firstName} ${lastName}`
 * 4. email
 * 5. hide field
 *
 * It also checks each potential value for `-` content to avoid displaying `- -`.
 *
 * @param {Object} p
 * @param {string} p.component          name of the status component
 * @param {?string} p.parent            optional name of the parent container in case its
 *                                      name is not unique
 * @returns {function(Gaia.AppModule.Spec): function(...[*]): Promise<*[]>}
 */
export default ({ component = 'name', parent = null, attribute = null } = {}) => module => async (components, ...args) => {
  const { [parent]: parentComponent } = components || {}
  const {
    [component]: targetComponent,
  } = find(parentComponent || module[G.STATE][G.ACTION][G.COMPONENT])

  if (targetComponent) {
    const targetModel = attribute
      ? module[G.MODEL][G.CHILDREN]?.attribute
      : module[G.MODEL]

    const {
      value: {
        name,
        firstName,
        lastName,
        contactChannels = [],
      } = {},
    } = getFirstItem(targetModel?.[G.CACHE] || [{}])

    const email = contactChannels.find(c => c.type === 'email')?.value

    if (name || (firstName && lastName) || email) {
      const nameValue = (_hasValue(name) && name)
        || (_hasValue(`${firstName} ${lastName}`) && `${firstName} ${lastName}`)
        || (_hasValue(email) && email)

      nameValue
        ? set(targetComponent, nameValue)
        : hide(targetComponent)
    } else {
      hide(targetComponent)
    }
  } else {
    hide(targetComponent)
  }

  return [components, ...args]
}
